import React from "react";
import { IconButton } from "@mui/material";
import dayjs from "dayjs";
import {
  CalendarIcon,
  ClockWithPlusIcon,
  DollarIcon,
  Delete,
} from "../../../../utils/svg-components";
import DummyField from "../../../../components/dummy-field/dummy-field";
import TextInputField from "../../../../components/form-fields/text-input-field/text-input-field";
import { formatNumber } from "../../../../utils/utils";
import DateRangePickerField from "../../../../components/form-fields/date-range-picker/date-range-picker";
import { applyDraftStatus } from "../../planner.utils";

const MilestoneHeader = ({
  milestone,
  isGeneralUser,
  milestoneIndex,
  onDeleteMilestone,
  handleMilestoneChange,
  hideLabels,
}) => {
  return (
    <div className="grid" onClick={(e) => e.stopPropagation()}>
      <div className="name-duration">
        <div className="name">
          {!isGeneralUser && (
            <IconButton onClick={onDeleteMilestone} className="delete">
              <Delete />
            </IconButton>
          )}
          <TextInputField
            value={milestone?.name || ""}
            label={hideLabels ? "" : "Deliverable Name*"}
            onChange={(e) =>
              handleMilestoneChange(milestoneIndex, "name", e.target.value)
            }
          />
        </div>
        <DummyField
          label={hideLabels ? "" : "Duration"}
          value={milestone?.dateRange || "mm-dd-yyyy | mm-dd-yyyy"}
          startIcon={<CalendarIcon />}
        />
      </div>
      <div className="dummyField">
        <DummyField
          label={hideLabels ? "" : "Hours"}
          value={formatNumber(milestone?.hours)}
          startIcon={<ClockWithPlusIcon />}
        />
        <DummyField
          label={hideLabels ? "" : "Value"}
          value={formatNumber(milestone?.budget)}
          startIcon={<DollarIcon />}
        />
      </div>
    </div>
  );
};

const MilestoneHeaderFixedProject = ({
  milestone,
  isGeneralUser,
  milestoneIndex,
  onDeleteMilestone,
  handleMilestoneChange,
  hideLabels,
}) => {
  return (
    <div className="deliv-header-fixed-project">
      {!isGeneralUser && (
        <IconButton onClick={onDeleteMilestone} className="delete">
          <Delete />
        </IconButton>
      )}
      <TextInputField
        value={milestone?.name || ""}
        label="Deliverable Name"
        onChange={(e) =>
          handleMilestoneChange(milestoneIndex, "name", e.target.value)
        }
      />
    </div>
  );
};

const MilestoneHeaderFixedDeliv = ({
  milestone,
  isGeneralUser,
  milestoneIndex,
  onDeleteMilestone,
  handleMilestoneChange,
  resources,
  handleStatusChange,
  project,
}) => {
  const [startStr, endStr] = (milestone.dateRange || "").split(" - ");
  const defaultRange =
    startStr && endStr
      ? [dayjs(startStr, "MM-DD-YYYY"), dayjs(endStr, "MM-DD-YYYY")]
      : [];
  const handleDateRangeChange = (newDateRange) => {
    // Assuming newDateRange is a string like "MM/DD/YYYY - MM/DD/YYYY"
    handleMilestoneChange(milestoneIndex, "dateRange", newDateRange);
  };

  const isServiceValueDisabled =
    !resources || !resources?.[0]?.rate || resources.length === 0;

  return (
    <div className="deliv-header-fixed-deliv">
      <div className="deliverable-name">
        {!isGeneralUser && (
          <IconButton onClick={onDeleteMilestone} className="delete">
            <Delete />
          </IconButton>
        )}
        <TextInputField
          value={milestone?.name || ""}
          label="Deliverable Name"
          onChange={(e) =>
            handleMilestoneChange(milestoneIndex, "name", e.target.value)
          }
        />
      </div>
      <div className="dummyField">
        <DateRangePickerField
          label="Duration"
          defaultValue={defaultRange}
          value={milestone.dateRange || ""}
          onChange={(dates, dateStrings) => {
            // Create a string representation of the date range if needed.
            const newDateRange = dateStrings.join(" - ");
            handleDateRangeChange(newDateRange);
          }}
        />

        <TextInputField
          value={milestone?.budget || ""}
          label="Value"
          placeholder="0.00"
          disabled={isServiceValueDisabled}
          InputProps={{ startAdornment: <DollarIcon /> }}
          onChange={(e) => {
            const value = e.target.value;
            applyDraftStatus(project, handleStatusChange);
            // Allow only numbers with up to 2 decimal places
            if (/^\d*\.?\d{0,2}$/.test(value)) {
              handleMilestoneChange(milestoneIndex, "budget", value);
            }
          }}
          inputType={"number"}
        />
      </div>
    </div>
  );
};

export {
  MilestoneHeader,
  MilestoneHeaderFixedProject,
  MilestoneHeaderFixedDeliv,
};
